const colors = {
  primary     : '#00496c',
  secondary   : '#ff9541',
  background  : {
    primary   : '#fff',
  },
  font        : {
    primary   : '#000',
    secondary : '#C0FDFB',
  },
  header      : {
    bg        : '#0e5f72'
  },
  footer      : {
    bg        : '#000',
    bgLight   : '#1ea0c0'
  },
  appBarMenu  : {
    bg        : '#0a424f',
    selectedBg: '#0a424f44'
  },
  button      : {
    bg        : '#af0000',
    color     : '#fff'
  }
}

export default colors